<script setup>
import { computed, ref } from '@vue/reactivity';
import { ApiService } from '@/axios/apiService';
import Modal from '@/components/ModalComponent.vue';
import { useStore } from 'vuex';

const store = useStore();
const apiService = new ApiService();
const props = defineProps({
    rows: {
        type: Array,
        required: true,
    },
    dataLength: Number,
    pageLength: Number,
    currentPage: Number,
    offset: Number,
    size: Number,
});
const emit = defineEmits(['getData']);

const alertType = ref('');
const successMessage = ref('');
const errorRes = ref('');
const selectedData = ref();
const willRemoved = ref({});

const detailPerangkat = async (id) => {
    const res = await apiService.getPerangkatId(id);
    selectedData.value = res.data;
};

const editPerangkat = async (id) => {
    const res = await apiService.getPerangkatId(id);
    selectedData.value = res.data;
};

const openAlert = (id, station, condition, body) => {
    let payload = {
        text: `data station ${station} akan di${condition} ?`,
        text1: '',
        funs: '',
    };
    if (condition === 'hapus') {
        payload.funs = async () => {
            try {
                await apiService.hapusPerangkatId(id);
                emit('getData');
                store.dispatch('swalSuccess', {
                    text: 'data berhasil dihapus',
                });
            } catch (error) {
                store.dispatch('swalError', {
                    code: error.response.data.status,
                    text: error.response.data.message,
                });
                console.log(error);
                return;
            }
        };
    } else if (condition === 'gudangkan') {
        payload.funs = async () => {
            try {
                const body_ = {
                    gudangAplikasi: body.appId,
                    gudangBatch: body.batch,
                    gudangClient: body.pelanggan.id,
                    gudangMts: body.mts,
                    gudangStation: body.station,
                    duplikatId: '',
                    perangkatId: body.id,
                };
                const res = await apiService.gudangkan(body_);
                store.dispatch('swalSuccess', {
                    text: 'data berhasil digudangkan',
                });
                emit('getData');
            } catch (error) {
                console.log(error);
            }
        };
    } else {
        console.log(condition);
    }
    store.dispatch('swalConfirm', payload);
};

const editAction = async (id) => {
    let payload = {
        text: '',
        code: '',
    };
    try {
        const data_ = selectedData.value;
        const data = {
            pelanggan_id: data_.pelanggan.id,
            mts: data_.mts,
            station: data_.station,
            provinsi: data_.provinsi,
            kabupaten: data_.kabupaten,
            batch: data_.batch,
            latitude: data_.latitude,
            longitude: data_.longitude,
        };
        const res = await apiService.editPerangkatId(id, data);
        payload.text = 'data berhasil di edit';
        store.dispatch('swalSuccess', payload);
        emit('getData');
    } catch (error) {
        payload.code = error.response.data.statusCode;
        payload.text = error.response.data.message;
        store.dispatch('swalError', payload);
    }
};

const firstIndex = computed(() => {
    if (props.dataLength > 0) {
        return props.offset + 1;
    } else {
        return 0;
    }
});

const lastIndex = computed(() => {
    if (props.offset + props.size <= props.dataLength) {
        return props.offset + 10;
    } else {
        return props.dataLength;
    }
});

const nol = (x) => {
    const y = x > 9 ? (x > 99 ? x : '' + x) : '0' + x;
    return y;
};
</script>

<template>
    <div>
        <div class="table-responsive p-0">
            <table class="table align-items-center mb-0">
                <thead>
                    <tr>
                        <th
                            class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7"
                        >
                            No.
                        </th>
                        <th
                            class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7"
                        >
                            TGL. UPLOAD
                        </th>
                        <th
                            class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7 ps-2"
                        >
                            MTS
                        </th>
                        <th
                            class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7"
                        >
                            STATION
                        </th>
                        <th
                            class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7"
                        >
                            KETERANGAN
                        </th>
                        <th></th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="(row, index) in props.rows" :key="index">
                        <td class="text-center align-middle text-sm">
                            <small>{{
                                props.currentPage > 0
                                    ? index + 1 + props.currentPage * 10
                                    : index + 1
                            }}</small>
                        </td>
                        <td class="text-center align-middle text-sm">
                            <small>
                                {{
                                    `${nol(row.tglUpload[2])} - ${nol(row.tglUpload[1])} - ${nol(
                                        row.tglUpload[0]
                                    )}`
                                }}
                            </small>
                        </td>
                        <td class="align-middle text-center text-sm">
                            <small>{{ row.mts }}</small>
                        </td>
                        <td class="align-middle text-center">
                            <small>{{ row.station }}</small>
                        </td>
                        <td class="align-middle">
                            <small>
                                TYPE : {{ row.type }} <br />
                                ZONE : {{ row.zone }} <br />
                                BATCH : {{ row.batch }}</small
                            >
                        </td>
                        <td>
                            <div
                                class="btn-group float-end"
                                role="group"
                                aria-label="Basic example"
                            >
                                <button
                                    @click="detailPerangkat(row.id)"
                                    title="Detail Perangkat"
                                    data-bs-toggle="modal"
                                    data-bs-target="#detailPerangkat"
                                    type="button"
                                    class="btn btn-success btn-sm px-2 py-1"
                                >
                                    <i class="fa fa-eye text-white"></i>
                                </button>
                                <button
                                    @click="editPerangkat(row.id)"
                                    title="Edit Perangkat"
                                    type="button"
                                    class="btn btn-success btn-sm px-2 py-1"
                                    data-bs-toggle="modal"
                                    data-bs-target="#editPerangkat"
                                >
                                    <i class="fa fa-pen text-white"></i>
                                </button>
                                <button
                                    @click="openAlert(row.id, row.station, 'hapus')"
                                    title="Hapus Perangkat"
                                    type="button"
                                    class="btn btn-success btn-sm px-2 py-1"
                                >
                                    <i class="fa fa-trash text-white"></i>
                                </button>
                                <button
                                    type="button"
                                    class="btn btn-success btn-sm px-2 py-1"
                                    @click="openAlert(row.id, row.station, 'gudangkan', row)"
                                    title="Gudangkan Perangkat"
                                >
                                    <i class="fa fa-check-circle text-white"></i>
                                </button>
                            </div>
                        </td>
                    </tr>
                </tbody>
            </table>
            <div class="row">
                <div class="col-6">
                    <h6>
                        Showing
                        {{ firstIndex }}
                        to
                        {{ lastIndex }}
                        from {{ props.dataLength }} entries
                    </h6>
                </div>
                <div class="col-6">
                    <div class="float-end">
                        <slot name="button"></slot>
                    </div>
                </div>
            </div>
        </div>
        <!-- modal -->
        <Modal
            :modalName="'detailPerangkat'"
            :isHeader="true"
            modalTitle="Detail Perangkat"
            :isFooter="false"
        >
            <template #body>
                <div class="p-0">
                    <div v-if="selectedData !== undefined">
                        <table class="table table-bordered">
                            <tr>
                                <th width="150" height="50">MTS</th>
                                <td>:&nbsp;</td>
                                <td>{{ selectedData.mts }}</td>
                            </tr>
                            <tr>
                                <th width="150" height="50">Station</th>
                                <td>:&nbsp;</td>
                                <td>{{ selectedData.station }}</td>
                            </tr>
                            <tr>
                                <th width="150" height="50">Pelanggan</th>
                                <td>:&nbsp;</td>
                                <td>{{ selectedData.pelanggan.name }}</td>
                            </tr>
                            <tr>
                                <th width="150" height="50">Posisi</th>
                                <td>:&nbsp;</td>
                                <td>{{ selectedData.longitude }}, {{ selectedData.latitude }}</td>
                            </tr>
                            <tr>
                                <th width="150" height="50">Alamat</th>
                                <td>:&nbsp;</td>
                                <td class="break-line-alamat">{{ selectedData.alamat }}</td>
                            </tr>
                            <tr>
                                <th width="150" height="50">Provinsi</th>
                                <td>:&nbsp;</td>
                                <td>{{ selectedData.provinsi }}</td>
                            </tr>
                            <tr>
                                <th width="150" height="50">Kabupaten</th>
                                <td>:&nbsp;</td>
                                <td>{{ selectedData.kabupatenkota }}</td>
                            </tr>
                            <tr>
                                <th width="150" height="50">Kecamatan</th>
                                <td>:&nbsp;</td>
                                <td>{{ selectedData.kecamatan }}</td>
                            </tr>
                            <tr>
                                <th width="150" height="50">Zona</th>
                                <td>:&nbsp;</td>
                                <td>{{ selectedData.zone }}</td>
                            </tr>
                            <tr>
                                <th width="150" height="50">Komstax PN</th>
                                <td>:&nbsp;</td>
                                <td>{{ selectedData.komstaxPn }}</td>
                            </tr>
                            <tr>
                                <th width="150" height="50">Komstax SN</th>
                                <td>:&nbsp;</td>
                                <td>{{ selectedData.komstaxSn }}</td>
                            </tr>
                        </table>
                        <!-- {{ selectedData }} -->
                    </div>
                </div>
                <div>
                    <button class="btn btn-success float-end" data-bs-dismiss="modal">Tutup</button>
                </div>
            </template>
        </Modal>
        <Modal
            modalSize="modal-lg"
            :modalName="'editPerangkat'"
            :isHeader="true"
            modalTitle="Edit Perangkat"
            :isFooter="false"
        >
            <template #body>
                <div class="row" v-if="selectedData !== undefined">
                    <div class="col-6">
                        <div class="mt-2">
                            <label for="mts">MTS</label>
                            <input
                                id="mts"
                                placeholder="MTS"
                                class="form-control"
                                type="text"
                                v-model="selectedData.mts"
                                disabled
                            />
                        </div>
                        <div class="mt-2">
                            <label for="station">Station</label>
                            <input
                                id="station"
                                placeholder="station"
                                class="form-control"
                                type="text"
                                v-model="selectedData.station"
                            />
                        </div>
                        <div class="mt-2">
                            <label for="longitude">Longitude</label>
                            <input
                                id="longitude"
                                placeholder="longitude"
                                class="form-control"
                                type="text"
                                v-model="selectedData.longitude"
                            />
                        </div>
                        <div class="mt-2">
                            <label for="latitude">Latitude</label>
                            <input
                                id="latitude"
                                placeholder="latitude"
                                class="form-control"
                                type="text"
                                v-model="selectedData.latitude"
                            />
                        </div>
                    </div>
                    <div class="col-6">
                        <div class="mt-2">
                            <label for="pelanggan">Pelanggan</label>
                            <input
                                id="pelanggan"
                                placeholder="pelanggan"
                                class="form-control"
                                type="text"
                                v-model="selectedData.pelanggan.name"
                                disabled
                            />
                        </div>
                        <div class="mt-2">
                            <label for="batch">Batch</label>
                            <input
                                id="batch"
                                placeholder="batch"
                                class="form-control"
                                type="text"
                                v-model="selectedData.batch"
                                disabled
                            />
                        </div>
                        <div class="mt-2">
                            <label for="provinsi">Provinsi</label>
                            <input
                                id="provinsi"
                                placeholder="provinsi"
                                class="form-control"
                                type="text"
                                v-model="selectedData.provinsi"
                            />
                        </div>
                        <div class="mt-2">
                            <label for="kabupaten">Kabupaten</label>
                            <input
                                id="kabupaten"
                                placeholder="kabupaten"
                                class="form-control"
                                type="text"
                                v-model="selectedData.kabupaten"
                            />
                        </div>
                    </div>
                </div>
                <div class="modal-footer mt-4">
                    <button
                        class="btn btn-success"
                        data-bs-dismiss="modal"
                        @click="editAction(selectedData.id)"
                    >
                        Submit
                    </button>
                    <button class="btn btn-outline-success" data-bs-dismiss="modal">Batal</button>
                </div>
            </template>
        </Modal>
    </div>
</template>
